import { render, staticRenderFns } from "./ContractRevise.vue?vue&type=template&id=b5119d46&scoped=true&"
import script from "./ContractRevise.vue?vue&type=script&lang=js&"
export * from "./ContractRevise.vue?vue&type=script&lang=js&"
import style0 from "./ContractRevise.vue?vue&type=style&index=0&id=b5119d46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5119d46",
  null
  
)

export default component.exports